// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductDevelopmentForm_wrapper__Ufycr","btn":"ProductDevelopmentForm_btn__kU+vH"};